import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  :root {
    --sidebar-width: 230px;
    --header-height: 120px;

    font-weight: 400;
    color-scheme: light dark;
    color:  ${({ theme }) => theme.body.textColor || 'rgb(23,23,23)'};
    background-color: ${({ theme }) => theme.body.bgColor || '#ffffff'};

    font-synthesis: none;
    text-rendering: optimizeLegibility;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: 100%;
  }

  html,
  body {
    font-family: ${(props) =>
      props.theme.fontName},'Helvetica','Helvetica Neue',Arial,sans-serif;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.6;
    min-height: 100%;
    width: 100%;
    min-width: 380px;
    margin: 0;
    padding: 0;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  #app {
    min-width: 100%;
    min-height: 100vh;
  }

  i {
    font-family: ${(props) =>
      props.theme.fontName},'Helvetica','Helvetica Neue',Arial,sans-serif;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
  }
  
  a {
    color: inherit;
    text-decoration: none;
    font-weight: 400;
  }

  .link {
    color: ${(props) => props.theme.primaryColor};

    &:hover {
      text-decoration: underline;
    }
  }
  
  p {
    margin: 0 0 1em;
  }

  input, select, button {
    font-family: ${(props) =>
      props.theme.fontName},'Helvetica','Helvetica Neue',Arial,sans-serif;;
    font-size: inherit;
  }

  b, strong {
    font-weight: 600;
  }

  .hide-stepper::-webkit-outer-spin-button,
  .hide-stepper::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .hide-stepper[type='number'] {
    -moz-appearance: textfield;
    appearance: textfield;
  }
`

/*
 * Media queries utility
 */

/*
 * Inspired by https://github.com/DefinitelyTyped/DefinitelyTyped/issues/32914
 */
// Update your breakpoints if you want
const sizes = {
  small: 600,
  medium: 1024,
  large: 1440,
  xlarge: 1920,
}

// Iterate through the sizes and create min-width media queries
export const media = (Object.keys(sizes) as Array<keyof typeof sizes>).reduce(
  (acc, size) => {
    acc[size] = () => `@media (min-width:${sizes[size]}px)`
    return acc
  },
  {} as { [key in keyof typeof sizes]: () => string }
)

/* Example
const SomeDiv = styled.div`
  display: flex;
  ....
  ${media.medium} {
    display: block
  }
`;
*/

export default GlobalStyle
